// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T1Zr","buttons":"styles_buttons__2yCj0"};